export enum ShopConnectionType {
    INTEGRATION_LAYER,
    WORDPRESS_PLUGIN,
    SHOPIFY_APP,
    NONE,
    AMAZON_SHOP,
    TIKTOK_SHOP,
}
